import React, { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function resolveUrl(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BACKEND}${url}`;
}

export default function LogoUpload({ value, onChange, color = "#A3E635" }) {
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("Datei zu gross (max. 5 MB)"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Logo hochgeladen");
    } catch (err) {
      toast.error("Upload fehlgeschlagen");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-16 h-16 rounded-lg border border-white/10 flex items-center justify-center overflow-hidden shrink-0"
        style={{ background: `${color}18` }}>
        {value ? <img src={resolveUrl(value)} alt="Logo" className="w-full h-full object-cover" /> : <span style={{ color }} className="text-xl font-black">?</span>}
      </div>
      <label data-testid="logo-upload" className="cursor-pointer bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg px-4 py-2.5 text-sm flex items-center gap-2 transition-colors">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {value ? "Logo ersetzen" : "Logo hochladen"}
        <input type="file" accept="image/*" onChange={upload} className="hidden" disabled={busy} />
      </label>
      {value && <button type="button" onClick={() => onChange("")} className="text-xs text-gray-500 hover:text-red-400">Entfernen</button>}
    </div>
  );
}
